namespace RecordShield.Modules.Workspace.SerialKeys {
    export enum KeyStatus {
        Created = 1,
        Open = 2,
        Activated = 3,
        Disabled = 4,
        Expired = 5
    }
    Serenity.Decorators.registerEnum(KeyStatus, 'SerialKeys.KeyStatus');
}
